import React from "react";
import { ArchiveBook } from "../../Utils/icons";
import "./style.scss";
const Container = ({ title = "", icon, children, dashboard, render }) => {
  return (
    <div
      className="container-card"
      data-height={dashboard ? "dashboard" : "false"}
    >
      {render ? (
        render()
      ) : (
        <div className="title-container">
          <span>{icon ? icon() : <ArchiveBook />}</span>
          <h5 className="fs-15 fw-700 lh-26 text-sub">{title}</h5>
        </div>
      )}

      <div className="body-container">{children}</div>
    </div>
  );
};

export default Container;
